import { StateService } from "@uirouter/angularjs";
import { IFieldArray, ITemplateScope } from "AngularFormly";
import { FormViewController } from "../../../../records/forms/formView/controller";
import { Record } from "../../../../records/server/crud";
import { IHasResponseStatus } from "../../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";

const apiUrl = "/api/machines/progressives/ProgressiveControllerType";

export class ProgressiveControllerTypeEditViewController {
  static $inject = [ServerUtilityName, "$state"];

  readonly formFields: IFieldArray;
  readonly progressiveControllerType: Record = { Id: 0 };

  constructor(
    private readonly serverUtility: ServerUtility,
    private readonly $state: StateService
  ) {
    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          {
            name: "Name",
            key: "Name",
            type: "input",
            templateOptions: {
              label: "Name",
              required: true,
            },
            asyncValidators: {
              unique: (
                $viewValue: any,
                $modelValue: any,
                scope: ITemplateScope
              ) => {
                const id = scope.model?.Id;
                return serverUtility
                  .alreadyExistsWrapped({
                    url: apiUrl,
                    query: { Name: $viewValue },
                    excludeId: id,
                  })
                  .then((alreadyTaken) => {
                    if (alreadyTaken) {
                      throw new Error();
                    }
                  });
              },
            },
          },
        ],
        4
      ),
    ];
  }

  submit(formViewController: FormViewController) {
    return this.serverUtility
      .postWithCrudRecordResponse({
        url: apiUrl,
        postObject: this.progressiveControllerType,
      })
      .then(() => {
        this.$state.go("^");
      })
      .catch((error) => {
        const apiResponse = <IHasResponseStatus>error.data;
        formViewController.setApiErrors(apiResponse.ResponseStatus);
      });
  }

  cancel() {
    return this.$state.go("^");
  }
}
